module.exports = __webpack_public_path__ + "static/media/react-bootstrap-carousel.f7448c04.ttf";